/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { CarEquipmentDtoFromJSON, CarEquipmentDtoToJSON, } from './';
export function GarageSpotUpdateDtoFromJSON(json) {
    return GarageSpotUpdateDtoFromJSONTyped(json, false);
}
export function GarageSpotUpdateDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'carId': !exists(json, 'carId') ? undefined : json['carId'],
        'equipments': !exists(json, 'equipments') ? undefined : (json['equipments'] === null ? null : json['equipments'].map(CarEquipmentDtoFromJSON)),
    };
}
export function GarageSpotUpdateDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'carId': value.carId,
        'equipments': value.equipments === undefined ? undefined : (value.equipments === null ? null : value.equipments.map(CarEquipmentDtoToJSON)),
    };
}
